import { Route } from "react-router-dom";
import RoleScreen from "../../../container/System/RoleScreen";
import CreateRoleContainer from "../../../container/System/RoleScreen/CreateRole";
import { APP_URLS } from "../../../utils/constant";

const RoleRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SYSTEM_ROLES.HOME}
          element={<RoleScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SYSTEM_ROLES.CREATE}
          element={<CreateRoleContainer isEdit={false} />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SYSTEM_ROLES.EDIT}
          element={<CreateRoleContainer isEdit={true} />}
        />
      )}
    </>
  );
};

export default RoleRoutes;
